var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXdBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xd-black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M0,0V512H512V0ZM489.471,489.475H22.525V22.529H489.47V489.475Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M265.8,137.064h-40l-42.932,89.794-43.508-89.794h-41.2l58.308,116.594L96.077,373.047H136.79l43.7-91.5,44.209,91.5h44.067L206.525,252.256Zm110.563,0v60H364.833c-39.329,0-86.875,25.363-86.875,90.145,0,50.081,25.375,87.723,79.422,87.723,39.8,0,58.544-13.766,58.544-13.766V137.064Zm-.038,203.4s-4.555,2.005-15.3,2.005-43.722-4.736-43.722-57.022,37.894-56.474,47-56.474,12.025,2.552,12.025,2.552V340.466Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdBlack);
export default __webpack_public_path__ + "static/media/xd-black.855f25b69aaa6b7abe431f6582fbf60c.svg";
export { ForwardRef as ReactComponent };